import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';

import { RequireOnlyOne } from '@utils/types';

import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

type TBreakpoint<T> = { [key in Breakpoint]: T };
type TProps = (
  | { height: number | string; spacing?: never }
  | { height?: never; spacing: number }
) &
  (Partial<TBreakpoint<never>> | RequireOnlyOne<TBreakpoint<boolean>>) & {
    type?: 'vertical' | 'horizontal';
  };

export const Spacer: React.FC<TProps> = ({
  height = undefined,
  spacing = undefined,
  type = 'vertical',
  ...breakpoint
}) => {
  const breakpoints = Object.keys(breakpoint) as Breakpoint[];
  const theme = useTheme();
  const useQueryMatch = useMediaQuery(theme.breakpoints.only(breakpoints[0]));
  const match = breakpoints.length ? useQueryMatch : true;
  const styleProp = type === 'vertical' ? 'height' : 'width';

  return match ? (
    <div
      {...(height || spacing
        ? {
            style: {
              [styleProp]: height ? height : theme.spacing(spacing!),
            },
          }
        : {})}
    >
      {'\u00A0'}
    </div>
  ) : null;
};
